import { BASE_URL } from "@funded-here-interface/common/src/constant/constant";
import axios from "axios";
import { LogoutRequest } from "../types/logout.type";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import { store } from "../store";
import { resetAuthState } from "@funded-here-interface/common/src/features/auth/authSlice_Investor";

const logout = async ({ token }: LogoutRequest) => {
  try {
    await axios.post(
      `${BASE_URL}/trade-directory/auth/logout`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    store.dispatch(resetAuthState());
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default logout;
